<template>
    <div>
        <v-layout row wrap justify-space-between>
            <v-flex md4>
                <v-text-field
                label="Irányítószám"
                @blur="fetchVarosLista();"
                v-model="cim.irszam"
                :rules="[rules.isIrszam, (v) => rules.required(v, 'Irányítószám kitöltése kötelező')]"
                :disabled="!editable"
                >
                </v-text-field>
            </v-flex>
            <v-flex md7>
                <v-select
                label="Város"
                v-model="cim.idvaros"
                append-icon="place"
                :items="varosLista"
                item-text="varos"
                item-value="idvaros"
                @change="fetchKozterLista();"
                :rules="[(v) => rules.required(v, 'Város kitöltése kötelező!')]"
                :disabled="!editable"
                >
                </v-select>
            </v-flex>
            <v-flex md12>
                <v-autocomplete
                label="Utca"
                :items="kozterLista"
                item-text="kozterulet"
                item-value="idkozterulet"
                v-model="cim.idkozterulet"
                :rules="[(v) => rules.required(v, 'Utca kitöltése kötelező')]"
                :disabled="!editable"
                >
                </v-autocomplete>
            </v-flex>
            <v-flex md3>
                <v-text-field
                label="Házszám - tól"
                v-model="cim.hsz_tol"
                :rules="[(v) => rules.required(v, 'Házszám kitöltése kötelező!')]"
                :disabled="!editable"
                >
                </v-text-field>
            </v-flex>
            <v-flex md3>
                <v-text-field
                label=" - ig"
                v-model="cim.hsz_ig"
                :disabled="!editable"
                >
                </v-text-field>
            </v-flex>
            <v-flex md3>
                <v-text-field
                label="épület"
                v-model="cim.epulet"
                :disabled="!editable"
                >
                </v-text-field>
            </v-flex>
            <v-flex md7>
                <v-select
                label="Emelet"
                v-model="cim.emelet"
                :items="emeletLista"
                item-text="emelet"
                item-value="idemelet"
                :disabled="!editable"
                >
                </v-select>
            </v-flex>
            <v-flex md3>
                <v-text-field
                label="Ajtó"
                v-model="cim.ajto"
                :disabled="!editable"
                >
                </v-text-field>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>

import cimService from '../../services/CimService';
import { rules } from '../../modules/Validators';

export default {
    data() {
        return {
            cim: {
                irszam: null,
                idvaros: null,
                idkozterulet: null,
                hsz_tol: null,
                hsz_ig: null,
                emelet: null,
                ajto: null,
                epulet: null,
            },
            rules,
            varosLista: [],
            kozterLista: [],
            emeletLista: [],
        };
    },

    computed: {
        cimType() {
            return this.levelcim ? 'levelezesi_cim' : 'cim';
        },

        szerzodoCim() {
            return this.index === -1;
        },

        getCim() {
            return this.szerzodoCim
                ? this.$store.getters.tarifaData.szerzodo[this.cimType]
                : this.$store.getters.biztositottak[this.index - 1][this.cimType];
        },

        loadCim() {
            return this.$store.getters.loadCim;
        },
    },

    watch: {
        cim: {
            handler() {
                if (this.levelcim) {
                    this.updateInput({}, { levelezesi_cim: this.cim });
                } else {
                    this.updateInput({}, { cim: this.cim });
                }
            },
            deep: true,
        },

        loadCim() {
            if (this.$store.getters.loadCim && !this.szerzodoCim) {
                this.cim.irszam = this.$store.getters.biztositottak[0].cim.irszam;
                this.cim.idvaros = this.$store.getters.biztositottak[0].cim.idvaros;
                this.cim.idkozterulet = this.$store.getters.biztositottak[0].cim.idkozterulet;
                this.cim.hsz_tol = this.$store.getters.biztositottak[0].cim.hsz_tol;
                this.cim.hsz_ig = this.$store.getters.biztositottak[0].cim.hsz_ig;
                this.cim.emelet = this.$store.getters.biztositottak[0].cim.emelet;
                this.cim.ajto = this.$store.getters.biztositottak[0].cim.ajto;
                this.updateInput({}, { cim: this.cim });

                if (this.cim.irszam > 1) {
                    this.init().then(() => {
                        cimService.getKozterLista(this.cim.idvaros).then((getKozterListaResponse) => {
                            this.kozterLista = getKozterListaResponse.data;
                            cimService.getEmeletLista().then((response) => {
                                this.emeletLista = response.data;
                                this.$store.commit('setLoadCim', false);
                            });
                        });
                    });
                }
            }
        },
    },

    methods: {

        fetchVarosLista() {
            cimService.getVarosLista(this.cim.irszam).then((response) => {
                this.varosLista = response.data;
            });
        },

        fetchKozterLista() {
            cimService.getKozterLista(this.cim.idvaros).then((response) => {
                this.kozterLista = response.data;
            });
        },

        init() {
            return new Promise((resolve, reject) => {
                cimService.getVarosLista(this.cim.irszam).then((response) => {
                    this.varosLista = response.data;
                    if (this.varosLista.length === 1) {
                        this.cim.idvaros = this.varosLista[0].idvaros;
                    }
                    resolve(response);
                }, (error) => {
                    reject(error);
                });
            });
        },

        updateInput(event, obj) {
            if (!this.szerzodoCim) {
                this.$store.dispatch('updateBiztositottProperty', { index: this.index - 1, obj, remove: false });
            } else if (this.cimType === 'levelezesi_cim') {
                this.$store.commit('updateSzerzodoLevelcim', this.cim);
            } else {
                this.$store.commit('updateSzerzodoCim', this.cim);
            }
        },
    },

    mounted() {
        cimService.getEmeletLista().then((response) => {
            this.emeletLista = response.data;
        });
        this.cim = { ...this.cimObj };
        if (this.cim.irszam > 1) {
            this.init().then(() => {
                cimService.getKozterLista(this.cim.idvaros).then((getKozterListaResponse) => {
                    this.kozterLista = getKozterListaResponse.data;
                    cimService.getEmeletLista().then((getEmeletListaResponse) => {
                        this.emeletLista = getEmeletListaResponse.data;
                    });
                });
            });
        }
    },

    props: {
        index: {
            type: Number,
            default: -1,
        },
        levelcim: {
            type: Boolean,
            default: false,
        },
        editable: {
            type: Boolean,
            default: true,
        },
        cimObj: {},
    },
};

</script>

<style scoped>

</style>
